import * as React from "react";
import * as ReactDOM from "react-dom/client";
import {createBrowserRouter, RouterProvider, Outlet} from "react-router-dom";
import { Provider } from "react-redux";
import appStore from "./utility/appStore";
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Contact from './pages/Contact';
import Matches from './pages/Matches';
import Players from './components/PlayerCard/Players';
import News from './pages/News';
import Gallery from './pages/Gallery';
import Contact from './pages/Contact';
import About from './pages/About';
import Error from "./pages/Error";
import './styles/App.css';

const AppLayout = ()=> (
    <Provider store={appStore}>
        <div className="app-container">
            <Navbar />
            <Outlet/>
            <Footer />
        </div>
    </Provider>
    
);
 //const About = React.lazy(()=>import('./components/AboutUs'));

 const appRouter = createBrowserRouter([{
    path: "/",
    element: <AppLayout/>,
    children: [
        {
            path: "/",
            element: <Home/>
        },
        {
            path: "/matches",
            element: (<React.Suspense><Matches/></React.Suspense>)
        },
        {
            path: "/players",
            element: <Players/>
        },
        {
            path: "/news",
            element: <News/>
        },
        {
            path: "/gallery",
            element: <Gallery/>
        },
        {
            path: "/contact",
            element: <Contact/>
        },
        {
            path: "/about",
            element: <About/>
        }
    ],
    errorElement: <Error/>
 },
 ])

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<RouterProvider router={appRouter}/>);
